<main>
  <div class="search-wrapper">
    <div class="search-bar-wrapper">
      <div class="search-bar">
        <input type="text" class="form-control" placeholder="Search"
               [(ngModel)]="keyword" (ngModelChange)="filterMatchingReleases()">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <button type="button" class="btn btn-primary" (click)="goToNewReleasePage()">New Release</button>
    </div>
  </div>

  @if (shownReleases.length > 0) {
    <ul class="releases-list">
      @for (release of shownReleases; track release.id) {
        <li class="release-card">
          <oaibox-release-row [release]="release"></oaibox-release-row>
        </li>
      }
    </ul>
  } @else {
    <div class="releases-list empty">
      <strong class="text-muted fs-5">No Releases</strong>
    </div>
  }
</main>
